"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventRelay = void 0;
var event_trigger_1 = require("../../utils/event-trigger");
var EventRelay = function (target) {
    return /** @class */ (function (_super) {
        __extends(EventRelay, _super);
        function EventRelay() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        EventRelay.prototype.binding = function (select, container) {
            var _this = this;
            _super.prototype.binding.call(this, select, container);
            var relayEvents = [
                'open', 'opening',
                'close', 'closing',
                'select', 'selecting',
                'unselect', 'unselecting',
                'clear', 'clearing'
            ];
            var preventableEvents = [
                'opening', 'closing', 'selecting', 'unselecting', 'clearing'
            ];
            select.on('*', function (name, params) {
                // Ignore events that should not be relayed
                if (relayEvents.indexOf(name) === -1) {
                    return;
                }
                // The parameters should always be an object
                params = params || {};
                // Generate the custom event for the TsSelect2 event
                var evt = event_trigger_1.eventTrigger(_this.core.element, 'select2:' + name, {
                    params: params
                });
                // Only handle preventable events if it was one
                if (preventableEvents.indexOf(name) === -1) {
                    return;
                }
                params.prevented = evt.defaultPrevented;
            });
        };
        return EventRelay;
    }(target));
};
exports.EventRelay = EventRelay;
//# sourceMappingURL=event-relay.js.map